import { render, staticRenderFns } from "./ReportGlobalFiltersBtn.vue?vue&type=template&id=6367f992"
import script from "./ReportGlobalFiltersBtn.vue?vue&type=script&lang=js"
export * from "./ReportGlobalFiltersBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports